(() => {
  let wantparse = true;
  let wantroots = false;

  function gbi(id) {
    return document.getElementById(id);
  }
  function qsa(sel) {
    return document.querySelectorAll(sel);
  }
  function html(id, htm) {
    gbi(id).innerHTML = htm;
  }
  function show(id, typ) {
    gbi(id).style.display = typ || 'block';
  }
  function hide(id) {
    gbi(id).style.display = 'none';
  }

  //SETUPUI

  function removehili() {
    const a = qsa('.selwd');
    let i,
      n = a.length;
    if (n > 0) {
      for (i = 0; i < n; i++) {
        a[i].classList.remove('selwd');
      }
    }
  }

  function hidexbox() {
    removehili();
    hide('xbox');
  }

  function selchange(e) {
    // event handler for clicks/taps on the 'roots' checkbox to turn it on/off
    let id, a, d, i, n;
    id = e.target.id;
    d = id.slice(8); // get id of the containing div, eg 'exp2-4'
    if (id === 'chkprs') {
      if (gbi('xbox')) {
        hidexbox();
      }
      wantparse = gbi(id).checked;
      if (gbi('parseline')) {
        if (wantparse) {
          show('parseline', 'block');
        } else {
          hide('parseline');
        }
      }
    } else if (id === 'chkroots') {
      wantroots = gbi(id).checked;
      a = gbi('activebook').querySelectorAll('.w'); // nb ignore any with class=wpers
      n = a.length;
      for (i = 0; i < n; i++) {
        d = gbi(a[i].id);
        if (d.dataset.root) {
          if (wantroots) {
            d.classList.add('ulin');
          } else {
            d.classList.remove('ulin');
          }
        }
      }
    }
  }

  // NB This is in the Word Explorer for story 2.3.
  // I noticed that 2.3 (Forum Boarium) is displaying all the pps of verbs and (I think)
  // the genitives of 3rd declension nouns. That got me thinking about what we might display
  // for the headwords and when. Perhaps aligning with the way we present vocabulary
  // in the learning lists at the back of the book would be the best option?
  // That would mean for nouns giving the accusative and gender from Chapters 2 to 10
  // (then switching to the genitive in 11), and for verbs giving the 1st person
  // (perhaps from Chpt. 2 rather than Chpt. 1?) then the infinitive from Chpt 5
  // and the 1st pers. perf. from Chpt. 7. For adjectives we'd give the 3 forms from Chapter 10.
  //
  // nouns: show accusative and gender from Chpt 2 to 10, then switch to the genitive in Chpt 11.
  //
  // verbs: show 1st person singular (perhaps from Chpt 2 rather than Chpt 1?)
  // 		then the infinitive from Chpt 5 and
  // 		the 1st pers. perf. from Chpt 7.
  //
  // adjectives: show the 3 forms from Chpt 10 (first chapter that show parsings).

  function getacc(gender, nom, gen) {
    let acc = '???';

    if (/a$/.test(nom) && /ae$/.test(gen)) {
      acc = `${nom}m`;
    } else if (/us$/.test(nom) && /ī$/.test(gen)) {
      acc = `${nom.slice(0, -1)}m`;
    } else if (/um$/.test(nom) && /ī$/.test(gen)) {
      acc = nom;
    } else if (/r$/.test(nom) && /rī$/.test(gen)) {
      acc = `${gen.slice(0, -1)}um`;
    } else if (/us$/.test(nom) && /ūs$/.test(gen)) {
      acc = `${nom.slice(0, -1)}m`;
    } else if (/is$/.test(gen)) {
      acc = gender === 'n' ? nom : `${gen.slice(0, -2)}em`;
    } else if (/ēs$/.test(nom) && /ēī$/.test(gen)) {
      acc = `${nom.slice(0, -2)}em`;
    } else if (/ēs$/.test(nom) && /um$/.test(gen)) {
      acc = nom;
    } else if (/ūs$/.test(nom) && /uum$/.test(gen)) {
      acc = nom;
    } else if (/ī$/.test(nom) && /ōrum$/.test(gen)) {
      acc = `${nom.slice(0, -1)}ōs`;
    } else if (/a$/.test(nom) && /um$/.test(gen)) {
      // neuter plurals (2nd & 3rd decls)
      acc = nom;
    } else if (/ae$/.test(nom) && /ārum$/.test(gen)) {
      acc = `${nom.slice(0, -2)}ās`;
    }
    return `${nom}, ${acc}`;
  }

  function filterhw(c, p, h) {
    // c = chapter num, p = parse code, h = headword
    let a,
      n = 0,
      nom,
      acc,
      t = h;
    a = h.split(/, */); // split headword into parts
    nom = a[0];
    if (/^v/.test(p)) {
      if (h !== 'inquit') {
        if (c > 1) {
          n++;
        } // 1st sing pres
        if (c > 4) {
          n++;
        } // infinitive
        if (c > 6) {
          n++;
        } // perfect
        a.length = n;
        t = a.join(', ');
      }
    } else if (/^n-/.test(p)) {
      t = c === 1 ? nom : h;
      if (c > 1 && c < 11 && a.length > 1) {
        t = getacc(p[7], nom, a[1]); // gender, nominative, genitive
      }
    } else if (/^r/.test(p)) {
      // pronoun
      t = c < 4 ? a[0] : h;
      if (c > 3 && c < 11 && a.length > 1) {
        if (nom === 'ego') {
          acc = 'mē';
        } else if (nom === 'tū') {
          acc = 'tē';
        } else if (nom === 'nōs') {
          acc = 'nōs';
        } else if (nom === 'vōs') {
          acc = 'vōs';
        }
        t = `${nom}, ${acc}`;
      }
    } else if (/^a-/.test(p)) {
      t = c < 10 ? a[0] : h;
    }
    return t;
  }

  function getOffsets(e) {
    let x = 0,
      y = 0;
    if (e.offsetParent) {
      do {
        x += e.offsetLeft;
        y += e.offsetTop;
        e = e.offsetParent;
      } while (e);
    }
    x = x < 0 ? 0 : x;
    y = y < 0 ? 0 : y;
    return { left: x, top: y };
  }

  function klap(e) {
    // event handler for clicks/taps on elements in the story explorers and interactive images
    let a,
      b,
      c,
      d,
      h,
      i,
      id,
      m,
      n,
      o,
      p,
      s,
      t,
      v,
      x,
      y,
      chap,
      inpicbox = false;
    let rect, xel, rx, xh, xw;
    let leftval, emwid, moveleft, wl, al, ar;
    let r, _topv, _lftv;

    t = e.target;
    p = t.parentElement;
    if (p) {
      inpicbox = /^s\d+-\d+-\d+$/.test(p.id);
    }
    id = t.id;
    if (id === 'xbox') {
      hidexbox();
    } else if (/^w\d+/.test(id)) {
      // word in a story explorer
      chap = +id.match(/^w(\d+)/)[1];
      n = id.slice(1).replace(/-\d+$/, '');
      a = qsa('.selwd');
      for (i = 0, m = a.length; i < m; i++) {
        // remove highlighting from all words currently highlit
        a[i].classList.remove('selwd');
      }
      b = t.dataset.prs.split('^');
      p = b[0]; // parse code
      h = b[1]; // headword
      if (/%/.test(h)) {
        h = h.replace(/%.+/, '');
      } else {
        h = filterhw(chap, p, h);
      }
      v = Expand.expand(p, chap);
      s =
        '<span class=lathwd>' +
        h +
        '</span>   ' +
        b[2].replace(/%.+/, '') +
        '<span class=pars id=parseline style="display:' +
        (wantparse && v !== '' ? 'block' : 'none') +
        '">' +
        v +
        '</span>';

      if (b.length > 3) {
        // there are notes on linked words
        c = b[3].split('+');
        s += `<div><span class=phrase>    ${c[1]}</span>   ${c[2]}</div`;
        d = c[0].split(',');
        for (i = 0, m = d.length; i < m; i++) {
          x = `w${n}-${d[i]}`;
          y = gbi(x);
          y.classList.add('selwd');
        }
      }
      if (wantroots) {
        // only show roots if 'roots' checkbox exists and is ticked
        d = t.dataset.root;
        if (d) {
          d = roots[d];
          d = d.replace(/\{/g, '\u2192\u2000<span class=rootlang>');
          d = d.replace(/\}/g, '</span>');
          s += `<div class=deriv>${d}</div>`;
        }
      }

      xel = gbi('xbox');
      xel.style.top = '0';
      xel.style.left = '0';
      xel.style.height = 'auto';
      xel.style.width = 'auto';
      //		html('xbox', '<div id=xboxtxt>' + s + '</div>');
      html('xbox', `<div id=xboxtxt class=${inpicbox ? 'bub1' : 'bub2'}>${s}</div>`);
      show('xbox', 'inline-block');

      h = gbi('header').getBoundingClientRect().height;
      rx = xel.getBoundingClientRect();
      xw = rx.right - rx.left;
      xh = rx.bottom - rx.top;

      o = getOffsets(gbi(id));
      xel.style.top = `${o.top - (xh + h + 30)}px`;
      wl = o.left;

      rect = gbi('activebook').getBoundingClientRect();
      al = rect.left;
      ar = rect.right;

      emwid = parseFloat(getComputedStyle(document.body).fontSize);
      leftval = wl - (al - emwid);
      if (ar - wl < xw) {
        moveleft = xw - (ar - wl);
      }
      moveleft = ar - wl < xw ? xw - (ar - wl) + emwid : 0;
      leftval = wl - (al + emwid / 2) - moveleft;
      xel.style.left = `${leftval}px`;

      t.classList.add('selwd'); // add highlight to newly clicked word
    } else if (/^s\d+-\dbg$/.test(id)) {
      x = gbi(id);
      r = x.getBoundingClientRect();
      _topv = (((e.clientY - r.top) * 100) / r.height).toFixed(1);
      _lftv = (((e.clientX - r.left) * 100) / r.width).toFixed(1);
      //		if ((r.width > 0) && ((topv >= 0) && (topv <= 100)) && ((lftv >= 0) && (lftv <= 100))) {
      //			console.log('==> top: ' + topv + '%, left: ' + lftv + '%');
      //		}
    } else {
      if (!/^chkprs/.test(id)) {
        if (gbi('xbox')) {
          hidexbox();
        }
      }
      if (/^pop-/.test(id)) {
        s = id.replace(/-\d+x*$/, '');
        s = s.replace(/^pop/, 'caption');
        d = gbi(s).style.display;
        if (d === '' || d === 'none') {
          html(s, t.dataset.cap);
          show(s);
          gbi(s).style.top = t.dataset.topoff;
        } else {
          hide(s);
        }
      } else if (/^caption-/.test(id)) {
        id = id.replace(/-\d+$/, ''); // strip uniquifying '-' + number from end of id
        hide(id);
      }
    }
  }

  //function loadweblinks() {
  //	fetch('./activebookxxx/weblnk.html')
  //	.then(r => r.text())
  //	.then(data => html('weblinkbox', data))
  //	.catch(() => html('weblinkbox', "Unable to load weblinks"));
  //}

  document.addEventListener('click', klap, false);
  document.addEventListener('change', selchange, false);
  window.addEventListener('resize', hidexbox, false);

  //loadweblinks();
})();
